var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPropertyStatus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#property_status_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  d: "M4.232 10.513V3.526h4.942v3.464zM14.435 31.148a5.47 5.47 0 0 1-3.55-5.528l.598-8.165c1.16-.432 2.111-1.316 2.627-2.63h7.777c.516 1.314 1.467 2.198 2.627 2.63l.597 8.165a5.47 5.47 0 0 1-3.55 5.528L18 32.474z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6E3037",
  d: "M15.673 22.891a.703.703 0 0 0-.994.995l2.118 2.118c.274.274.72.274.994 0l3.53-3.53a.703.703 0 1 0-.994-.995l-3.033 3.033z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6E3037",
  d: "M35.705 12.454 18.408.131a.7.7 0 0 0-.816 0L.295 12.454a.7.7 0 0 0-.295.573v6.032a.703.703 0 0 0 1.103.578l1.721-1.192v16.852c0 .388.315.703.703.703h28.946a.703.703 0 0 0 .703-.703V18.445l1.72 1.192A.702.702 0 0 0 36 19.059v-6.032c0-.227-.11-.44-.295-.573m-3.935 22.14H4.23V17.47L18 7.933l13.77 9.538zm2.824-16.877L18.4 6.5a.7.7 0 0 0-.8 0L1.406 17.717v-4.328L18 1.566 34.594 13.39z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "property_status_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v36H0z"
})))));
export default SvgPropertyStatus;